import { useState } from "react";
import API from "../../../services/api";
import { useNavigate } from "react-router-dom";
import "./hostel.css";

export default function AddHostel() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [wardenName, setWardenName] = useState("");
  const [hostelFee, setHostelFee] = useState("");

  const addHostel = async () => {
    if (!name.trim()) {
      alert("Enter hostel name");
      return;
    }

    const payload = {
      name,
      warden_name: wardenName,
      hostel_fee_amount: hostelFee || 0,
    };

    await API.post("/school-admin/hostels/", payload, {
      headers: { "X-SCHOOL-ID": school.school.id },
    });

    navigate("/school-admin/hostels");
  };

  return (
    <div className="hostel-form-page">
      <div className="hostel-form-card">

        {/* HEADER */}
        <div className="hostel-form-header">
          <span>🏠</span>
          <div>
            <h2>Add New Hostel</h2>
            <p>Fill in the details below to register a hostel</p>
          </div>
        </div>

        {/* FIELDS */}
        <div className="hostel-form-body">
          <div className="hostel-field">
            <label>Hostel Name *</label>
            <input
              placeholder="e.g. Boys Hostel A"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="hostel-field">
            <label>Warden Name</label>
            <input
              placeholder="e.g. Mr. Sharma"
              value={wardenName}
              onChange={(e) => setWardenName(e.target.value)}
            />
          </div>

          <div className="hostel-field">
            <label>Monthly Fee (Optional)</label>
            <input
              type="number"
              placeholder="e.g. 2000"
              value={hostelFee}
              onChange={(e) => setHostelFee(e.target.value)}
            />
          </div>
        </div>

        {/* ACTIONS */}
        <div className="hostel-form-actions">
          <button
            className="hostel-cancel-btn"
            onClick={() => navigate("/school-admin/hostels")}
          >
            Cancel
          </button>
          <button className="hostel-save-btn" onClick={addHostel}>
            Save Hostel
          </button>
        </div>
      </div>
    </div>
  );
}